"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Browser = void 0;
/**
 * Created by wangtong on 2021/1/5
 */
var Download = require("downloadjs");
var Browser;
(function (Browser) {
    // 设置浏览器头部标题
    function setTitle(title) {
        title = title ? "" + title : '散弹';
        window.document.title = title;
    }
    Browser.setTitle = setTitle;
    /**
     * 设置浏览器头部标题
     */
    function downloadText(text, filename, mimeType) {
        if (filename === void 0) { filename = 'download.txt'; }
        if (mimeType === void 0) { mimeType = "text/plain"; }
        Download(text, filename, mimeType);
    }
    Browser.downloadText = downloadText;
    function downloadUrl(url, filename) {
        var url_split = url.split('/');
        filename = filename || url_split[url_split.length - 1];
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', filename);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        if (document.createEvent) {
            var event_1 = document.createEvent('MouseEvents');
            event_1.initEvent('click', true, true);
            element.dispatchEvent(event_1);
        }
        else {
            element.click();
        }
    }
    Browser.downloadUrl = downloadUrl;
    function getImageSize(image_url) {
        var img = new Image();
        img.src = image_url;
        return new Promise(function (resolve) {
            // 判断是否有缓存
            if (img.complete) {
                resolve({
                    width: img.width,
                    height: img.height
                });
            }
            else {
                // 加载完成执行
                img.onload = function () {
                    resolve({
                        width: img.width,
                        height: img.height
                    });
                };
            }
        });
    }
    Browser.getImageSize = getImageSize;
    function selectFile() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var accept = args[0];
        var callback = args[1];
        var multiple = args[2];
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('name', 'file');
        input.setAttribute('accept', accept);
        if (multiple) {
            input.setAttribute('multiple', 'multiple');
        }
        input.oninput = function (event) {
            var _a;
            // @ts-ignore
            var files = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) || [];
            if (multiple) {
                // 这里非常重要，如果不用Array.from对files进行处理，那么files不会被视为一个数组
                callback(Array.from(files));
            }
            else if (files.length > 0) {
                callback(files[0]);
            }
        };
        input.click();
    }
    Browser.selectFile = selectFile;
    function readFileAsBinaryString(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (event) {
                var _a;
                resolve(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result) || null);
            };
            reader.readAsBinaryString(file);
        });
    }
    Browser.readFileAsBinaryString = readFileAsBinaryString;
    function readFileAsText(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (event) {
                var _a;
                resolve(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result) || null);
            };
            reader.readAsText(file, 'utf-8');
        });
    }
    Browser.readFileAsText = readFileAsText;
    function readFileAsDataURL(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (event) {
                var _a;
                resolve(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result) || null);
            };
            reader.readAsDataURL(file);
        });
    }
    Browser.readFileAsDataURL = readFileAsDataURL;
    function copyToClipboard(text) {
        text = text || '';
        if (typeof text === 'object') {
            text = JSON.stringify(text);
        }
        var aux = document.createElement('textarea');
        aux.setAttribute('readonly', 'readonly');
        aux.value = text;
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
    }
    Browser.copyToClipboard = copyToClipboard;
    /**
     * 从剪贴板上获取图片
     * @param event: 粘贴事件
     * @return {Promise<string | ArrayBuffer | null>} 图片的base64
     */
    function getImageFileFromClipboard(event) {
        return new Promise(function (resolve) {
            //获取clipboardData对象
            // @ts-ignore
            var data = event.clipboardData || (window === null || window === void 0 ? void 0 : window.clipboardData);
            var items = data.items || [];
            var file = null;
            if (items && items.length) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf('image') !== -1) {
                        file = items[i].getAsFile();
                    }
                }
            }
            if (file) {
                resolve(file);
            }
            else {
                resolve(null);
            }
        });
    }
    /**
     * 从剪贴板上获取图片
     * @param event: 粘贴事件
     * @return {Promise<string | ArrayBuffer | null>} 图片的base64
     */
    function getImageBase64FromClipboard(event) {
        return new Promise(function (resolve) {
            //获取clipboardData对象
            // @ts-ignore
            var data = event.clipboardData || (window === null || window === void 0 ? void 0 : window.clipboardData);
            var items = data.items || [];
            var file = null;
            if (items && items.length) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].type.indexOf('image') !== -1) {
                        file = items[i].getAsFile();
                    }
                }
            }
            if (file) {
                //将文件读取为 DataURL
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (event) {
                    var _a;
                    //获取base64流
                    resolve(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result) || null);
                };
            }
            else {
                resolve(null);
            }
        });
    }
    Browser.getImageBase64FromClipboard = getImageBase64FromClipboard;
})(Browser || (Browser = {}));
exports.Browser = Browser;
//# sourceMappingURL=browser.js.map